var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDomainIp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.118,
    height: 20.335,
    viewBox: "0 0 17.118 20.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M10.763,20.335H3.177A3.181,3.181,0,0,1,0,17.158V6.394A3.181,3.181,0,0,1,3.177,3.217h7.586a3.181,3.181,0,0,1,3.177,3.177V17.158A3.181,3.181,0,0,1,10.763,20.335ZM3.177,4.806A1.591,1.591,0,0,0,1.589,6.394V17.158a1.591,1.591,0,0,0,1.589,1.589h7.586a1.591,1.591,0,0,0,1.589-1.589V6.394a1.591,1.591,0,0,0-1.589-1.589ZM17.118,15.172V3.177A3.181,3.181,0,0,0,13.941,0H5.124a.794.794,0,1,0,0,1.589h8.817a1.591,1.591,0,0,1,1.589,1.589V15.172a.794.794,0,1,0,1.589,0Zm0,0",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDomainIp);
export default __webpack_public_path__ + "static/media/IconDomainIP.bccda5b3.svg";
export { ForwardRef as ReactComponent };